/**
 * compare-labels.js — merges the compare table's feature labels into each card's value rows.
 *
 * On desktop the labels live once in the left ".compare__desc" column and the cards are
 * value-only. On mobile that column is hidden and the cards become a carousel, so the bare
 * values ("500", "1X", "5%"…) lose their meaning. This injects each label into the matching
 * ".compare__value" cell so mobile can render "<value> <label>" (e.g. "500 exclusive giveaway
 * entries"). The label span is hidden on desktop via CSS, so desktop is unchanged.
 *
 * Idempotent + self-guarded: safe to load once from each compare block.
 */
(function () {
  if (window.__compareLabelsInit) return;
  window.__compareLabelsInit = true;

  function enhance(table) {
    const labels = Array.from(
      table.querySelectorAll('.compare__desc-row'),
      (n) => n.textContent.trim()
    );
    if (!labels.length) return;

    table.querySelectorAll('.compare__values').forEach((col) => {
      col.querySelectorAll('.compare__value').forEach((cell, i) => {
        if (cell.querySelector('.compare__value-mark')) return; // already processed
        const raw = cell.textContent.trim();

        const mark = document.createElement('span');
        mark.className = 'compare__value-mark';
        mark.textContent = raw;

        cell.textContent = '';
        cell.appendChild(mark);

        const label = labels[i];
        if (label) {
          const lab = document.createElement('span');
          lab.className = 'compare__value-label';
          lab.textContent = label;
          cell.appendChild(lab);
        }

        if (raw === '✓') cell.classList.add('compare__value--check'); // ✓ → label only on mobile
      });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.compare__table').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }
  // Theme editor: re-run when a section reloads.
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
